var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeOutlinedSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 6 23 19.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "like"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1645 8.74105L16.5 9.04471L16.8355 8.74105C17.7785 7.88755 19.6586 6.5 21.8393 6.5C24.9554 6.5 27.5 9.06484 27.5 12.229C27.5 13.1637 27.0732 14.0932 26.5982 14.8292C26.129 15.5563 25.6496 16.0382 25.6206 16.0673L25.6189 16.0691L16.5 25.289L7.37621 16.0641L7.37622 16.0641L7.37434 16.0622C7.34804 16.0359 6.86991 15.5552 6.40126 14.8287C5.92685 14.0932 5.5 13.1637 5.5 12.229C5.5 9.06484 8.04461 6.5 11.1607 6.5C13.3414 6.5 15.2215 7.88755 16.1645 8.74105Z",
    fill: "#4B3628",
    stroke: "#FFDCA8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeOutlinedSvg);
export default __webpack_public_path__ + "static/media/LikeOutlinedSVG.fc051b4fc4c366e8f3410fe0eb091e6c.svg";
export { ForwardRef as ReactComponent };